import { Component, Prop, Vue } from 'vue-property-decorator';
import { Themes } from '@/common/classes/themes';

@Component({})
export default class CoreThemeMixin extends Vue {
    @Prop({ default: '' }) public color!: Themes | '';
}
